import React from 'react';
import { Route, Switch } from 'react-router-dom';
import List from 'components/Referrals/List';

export default class Referrals extends React.Component {
  render = () => {
    const { match } = this.props;
    return (
      <div>
        <Switch>
          <Route exact path='/referrals' component={List}/>
        </Switch>
      </div>
    );
  };
}



// WEBPACK FOOTER //
// ./src/components/Referrals/index.js